const registeredSensorServiceQueues = [];

export default registeredSensorServiceQueues;
